export const semarctjjd = {
    agencyCode: '000644',
    name: 'Search Engine for Multi Agency Reportable Conduct',
    shortName: 'semarc',
    slug: 'semarctjjd',
  };